import { zFallback } from "src/utils/apis/common";
import { z } from "zod";

const {
    REACT_APP_FEATURE_VERSION
} = process.env;

const FeatureVersionSchema = z.enum(['development','testnet','production']);
export const FEATURE_VERSION = FeatureVersionSchema.or(zFallback<z.infer<typeof FeatureVersionSchema>>('development')).parse(REACT_APP_FEATURE_VERSION);
